import { Helpers } from '../../helpers';
import { IConstraintPrematureWellShutdownDetail } from '../../interfaces/iconstraint-premature-well-shutdown-detail';
import { Area } from '../area';
import { ConstraintPrematureWellShutdown } from '../constraint-premature-well-shutdown';
import { ConstraintPrematureWellShutdownInteractingTargetFormation } from '../constraint-premature-well-shutdown-interacting-target-formation';
import { TargetFormation } from '../target-formation';

export class ConstraintPrematureWellShutdownDetailBase {
  ConstraintPrematureWellShutdownDetailId: number;
  ConstraintPrematureWellShutdownId: number;
  TargetFormationId: number;
  OffsetXDistance: number | null;
  OffsetYDistance: number | null;
  MinimumProducingDays: number | null;
  AreaId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintPrematureWellShutdownInteractingTargetFormations_ConstraintPrematureWellShutdownDetail?: Array<ConstraintPrematureWellShutdownInteractingTargetFormation> | null;
  Area?: Area;
  ConstraintPrematureWellShutdown?: ConstraintPrematureWellShutdown;
  TargetFormation?: TargetFormation;

  constructor(item?: IConstraintPrematureWellShutdownDetail) {
    if (item) {

      this.ConstraintPrematureWellShutdownDetailId = item.ConstraintPrematureWellShutdownDetailId;
      this.ConstraintPrematureWellShutdownId = item.ConstraintPrematureWellShutdownId;
      this.TargetFormationId = item.TargetFormationId;
      this.OffsetXDistance = item.OffsetXDistance;
      this.OffsetYDistance = item.OffsetYDistance;
      this.MinimumProducingDays = item.MinimumProducingDays;
      this.AreaId = item.AreaId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintPrematureWellShutdownInteractingTargetFormations_ConstraintPrematureWellShutdownDetail = Helpers.createClassArray(ConstraintPrematureWellShutdownInteractingTargetFormation, item.ConstraintPrematureWellShutdownInteractingTargetFormations_ConstraintPrematureWellShutdownDetail);
      this.Area = new Area(item.Area);
      this.ConstraintPrematureWellShutdown = new ConstraintPrematureWellShutdown(item.ConstraintPrematureWellShutdown);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
    }
  }
}